

















import Vue from 'vue'

export default Vue.extend({
  name: 'InputListenerButton',
  props: {
    icon: {
      type: String,
      default: 'fas fa-qrcode'
    },
    delayTime: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      keyPressListener: '' as any,
      keyPressTimer: 0,
      keyPressSwitch: false,
      keyPressInput: '',
      loading: false,
      reverse: false,
      reverseTimer: 0
    }
  },
  computed: {
    iconColor(): string {
      return this.reverse
        ? 'warning'
        : this.keyPressSwitch
          ? 'success'
          : 'red'
    }
  },
  watch: {
    keyPressSwitch() {
      this.keyPressSwitch
        ? window.addEventListener('keypress', this.keyPressListener, false)
        : window.removeEventListener('keypress', this.keyPressListener, true)
    },
    keyPressInput() {
      if ((this.keyPressSwitch || this.reverse) && this.keyPressTimer === 0) {
        this.loading = true
        this.keyPressTimer = setTimeout(() => {
          this.notify()
          this.resetTimer()
        }, this.delayTime)
      }
    }
  },
  created() {
    this.keyPressListener = (ev: KeyboardEvent) => (this.keyPressInput += ev.key)
  },
  mounted() {
    const element = document.getElementById('barcode_listner')
    if (element) {
      element.addEventListener('mouseup', ev => clearTimeout(this.reverseTimer))
      element.addEventListener('mousedown', ev => {
        this.reverseTimer = setTimeout(() => (this.reverse = !this.reverse), 1000)
      })
    }
  },
  methods: {
    resetTimer() {
      this.keyPressInput = ''
      this.keyPressTimer = 0
      clearTimeout(this.keyPressTimer)
      this.loading = false
    },
    notify() {
      if (this.keyPressInput !== '') {
        const input = this.keyPressInput.replace('Enter', '')
        if (this.reverse) {
          this.$emit('reverse-input-event', input, true)
        } else {
          this.$emit('input-event', input, false)
        }
      }
    }
  }
})
